import { api, tokens } from "@/lib/api";

let timer = null;
let last = "";

// Sayfa görüntüleme olayı (800 ms debounce, aynı rota tekrarlanmaz)
export function trackPage(route, title) {
  clearTimeout(timer);
  timer = setTimeout(() => {
    if (!tokens.access() || route === last) return;
    last = route;
    api.post("/activity/page-view", { route, title: title || "" }).catch(() => {});
  }, 800);
}

export function trackEvent(action, extra = {}) {
  if (!tokens.access()) return;
  api.post("/activity/event", { action, route: window.location.pathname + window.location.search, title: document.title || "", ...extra }).catch(() => {});
}

if (typeof window !== "undefined" && !window.__istocPrintHook) {
  window.__istocPrintHook = true;
  window.addEventListener("beforeprint", () => trackEvent("YAZDIRMA", { summary: `Yazdırma · ${window.location.pathname}` }));
}
